/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BucketsResDto } from '../../models/buckets-res-dto';
import { CreateBucketsDto } from '../../models/create-buckets-dto';

export interface BucketsControllerCreateBucket$Params {
  body: CreateBucketsDto;
}

export function bucketsControllerCreateBucket(
  http: HttpClient,
  rootUrl: string,
  params: BucketsControllerCreateBucket$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<BucketsResDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    bucketsControllerCreateBucket.PATH,
    'post',
  );
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BucketsResDto>;
      }),
    );
}

bucketsControllerCreateBucket.PATH = '/';
